'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redial = require('redial');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _glamor = require('glamor');

var _Collection = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/Collection');

var _Collection2 = _interopRequireDefault(_Collection);

var _index = require('../../utils/index');

var _packs = require('redux/modules/packs');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var packStyle = (0, _glamor.css)({
  width: '50%',
  float: 'left',
  overflow: 'hidden',

  '& section': {
    borderTop: '2px solid black',
    borderRight: '2px solid black'
  },

  '& section:nth-child(even)': {
    borderRight: 'none'
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  width: '100%'
}));

var cf = function cf(path) {
  var arr = path.split('/');
  arr[0] = 'https://d3uwib8iif8w1p.cloudfront.net/megascans';
  return arr.join('/');
};

var Collections = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch,
        collectionType = _ref.params.collectionType;

    return _bluebird2.default.all([dispatch((0, _packs.loadPacksPage)({ collectionType: collectionType }))]);
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    collections: state.packs
  };
}), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(Collections, _React$Component);

  function Collections() {
    (0, _classCallCheck3.default)(this, Collections);
    return (0, _possibleConstructorReturn3.default)(this, (Collections.__proto__ || (0, _getPrototypeOf2.default)(Collections)).apply(this, arguments));
  }

  (0, _createClass3.default)(Collections, [{
    key: 'render',
    value: function render() {

      var isArchviz = this.props.location.pathname.indexOf('library/archviz') > -1;

      return _react2.default.createElement(
        'ul',
        null,
        this.props.collections.packs.map(function (collection) {
          return _react2.default.createElement(
            'li',
            { className: packStyle, key: collection.id },
            _react2.default.createElement(_Collection2.default, {
              img: cf(collection.presentation.splashImage),
              title: collection.name,
              description: collection.presentation.subtitle,
              primaryLabel: 'View Assets',
              primaryLink: (isArchviz ? '/megascans/library/archviz/packs/' : '/megascans/library/packs/') + collection.id
            })
          );
        })
      );
    }
  }]);
  return Collections;
}(_react2.default.Component)) || _class) || _class);
exports.default = Collections;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Library/Collections.jsx
// module id = 2894
// module chunks = 0